module.exports = __webpack_public_path__ + "media/images/adp_free_sponsorship-d80ef3fe47deeecd246d9caf833d816a.png";